import * as cookie from 'js-cookie';
import session from 'lib/session';
import React from 'react';
import { Redirect } from 'react-router';

export default ({ match }) => {
  session.kcToken = (window.location.search + '').replace('?token=', '');
  cookie.remove(session.AUTH_TOKEN_KEY);

  return React.createElement(Redirect, {
    to: '/',
  });
};
